import { render } from "./TypeBotNav.vue?vue&type=template&id=165a3949"
import script from "./TypeBotNav.vue?vue&type=script&lang=js"
export * from "./TypeBotNav.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\riverlea-new-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__